module.exports = __webpack_public_path__ + "img/title.64d305e4.png";